import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import Textarea from "primevue/textarea";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', value: string): void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Textarea), {
    value: __props.modelValue,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value))),
    class: _normalizeClass(["form-control", { 'is-invalid p-invalid': __props.invalid }])
  }, null, 8, ["value", "class"]))
}
}

})